(() => {
  if (window.__skyArticlePromptInitialized) return;
  window.__skyArticlePromptInitialized = true;

  function createPromptBox(source) {
    const paragraphs = Array.from(source.querySelectorAll('p'))
      .map((paragraph) => paragraph.textContent.trim())
      .filter(Boolean);
    const originalText = paragraphs.length ? paragraphs.join('\n\n') : source.textContent.trim();
    if (!originalText) return;

    const box = document.createElement('div');
    box.className = 'sky-article-prompt';

    const header = document.createElement('div');
    header.className = 'sky-article-prompt__header';

    const heading = document.createElement('div');
    const label = document.createElement('span');
    label.className = 'sky-article-prompt__label';
    label.textContent = 'Editable prompt';
    const hint = document.createElement('span');
    hint.className = 'sky-article-prompt__hint';
    hint.textContent = 'Edit freely · Changes reset on refresh';
    heading.append(label, hint);

    const copyButton = document.createElement('button');
    copyButton.className = 'sky-article-prompt__copy';
    copyButton.type = 'button';
    copyButton.textContent = 'Copy prompt';
    copyButton.setAttribute('aria-label', 'Copy edited prompt');

    const editor = document.createElement('textarea');
    editor.className = 'sky-article-prompt__editor';
    editor.setAttribute('aria-label', 'Editable prompt text');
    editor.setAttribute('spellcheck', 'false');
    editor.value = originalText;

    const status = document.createElement('span');
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');

    copyButton.addEventListener('click', async () => {
      let copied = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(editor.value);
          copied = true;
        }
      } catch (_) {
        copied = false;
      }
      if (!copied) {
        editor.focus();
        editor.select();
        try {
          copied = document.execCommand('copy');
        } catch (_) {
          copied = false;
        }
      }
      copyButton.textContent = copied ? 'Copied' : 'Select text';
      status.textContent = copied ? 'Prompt copied to clipboard.' : 'Select the prompt text to copy it.';
    });

    editor.addEventListener('input', () => {
      copyButton.textContent = 'Copy prompt';
      status.textContent = '';
    });

    header.append(heading, copyButton);
    box.append(header, editor, status);
    source.replaceWith(box);
  }

  function enhancePrompts(root) {
    root.querySelectorAll('.sky-article-guide__content blockquote').forEach((source) => {
      const marker = source.getAttribute('style') || '';
      if (!source.matches('.sky-prompt-source, [data-sky-prompt]') && !marker.toLowerCase().includes('#2856f0')) return;
      createPromptBox(source);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhancePrompts(document), { once: true });
  } else {
    enhancePrompts(document);
  }
  document.addEventListener('shopify:section:load', (event) => enhancePrompts(event.target));
})();
